import type { Optional } from '@festina-life/core'
import { useCallback, useEffect, useState } from 'react'

import type { FPlusCodeEditorLanguageServerInput } from '../types/monaco'
import { FPlusCodeEditor } from './FPlusCodeEditor'

export type Props = {
  editorInput: FPlusCodeEditorLanguageServerInput
  initialCode: Optional<string>
  onEvaluatePressed: () => void
  onCodeChanged?: (code: Optional<string>) => void
}

export const FPlusEvaluatingCodeEditor = ({
  editorInput,
  initialCode,
  onEvaluatePressed,
  onCodeChanged,
}: Props) => {
  const [code, setCode] = useState<string>(initialCode ?? '')

  const handleEvaluateKeyPress = useCallback(
    (event: KeyboardEvent) => {
      if (event.altKey && event.key == 'Enter') {
        onEvaluatePressed()
      }
    },
    [onEvaluatePressed],
  )

  useEffect(() => {
    // attach the event listener
    document.addEventListener('keydown', handleEvaluateKeyPress)

    // remove the event listener
    return () => {
      document.removeEventListener('keydown', handleEvaluateKeyPress)
    }
  }, [handleEvaluateKeyPress])

  const handleCodeChanged = useCallback(
    (nextCode: string) => {
      onCodeChanged?.(nextCode)
      setCode(nextCode)
    },
    [onCodeChanged],
  )

  return (
    <FPlusCodeEditor
      initialCode={code}
      onChangeCode={handleCodeChanged}
      editorInput={editorInput}
    />
  )
}
